export default __webpack_public_path__ + "887b980a9db3d5b169bd6e121f4b0692.png";